export default {
	methods: {
		arrayFromString (string) {
			if (string) {
				return string.split(',')
			}
		}
	}
}
